export default __webpack_public_path__ + "media/images/Design-Clair-1fcb4477f6381ce0a3f6cf18ce2cab28.jpg";